import { OrganizationAction } from "@common/userOrganizationRoles";
import { useCanPerformOrganizationAction } from "./useCanPerformOrganizationAction";

export function useCanViewAgentUsage(): boolean {
    return useCanPerformOrganizationAction(OrganizationAction.VIEW_AGENT_USAGE);
}
